import { push } from 'connected-react-router';
import { createAction, createAsyncAction } from '../actions';
import { loadHistory } from '../../_core/utils';

const OPEN_LOGOUT_DIALOGUE = createAction('OPEN_LOGOUT_DIALOGUE', () => (true));
const CLOSE_LOGOUT_DIALOGUE = createAction('CLOSE_LOGOUT_DIALOGUE', () => (false));
const resize = createAction('RESIZE', () => Math.min(window.innerWidth, window.outerWidth));
const TOGGLE_MENU = createAction('TOGGLE_MENU', open => (open));
const TOGGLE_MENU_MOBILE = createAction('TOGGLE_MENU_MOBILE', open => (open));
const GET_USER_WALLET_ADDRESS = createAction('GET_USER_WALLET_ADDRESS');
const SET_BUSINESS_MODE = createAction('SET_BUSINESS_MODE', isBusiness => (isBusiness));
const SET_BUSINESS_MODE_PATH = createAction('SET_BUSINESS_MODE_PATH', isBusiness => (isBusiness));
const SET_BACKEND_MODE = createAction('SET_BACKEND_MODE', isBackend => (isBackend));
const SHOW_WELCOME_MODAL = createAction('SHOW_WELCOME_MODAL', showWelcomeModal => (showWelcomeModal));
const SET_MAINTENANCE_MODE = createAction('SET_MAINTENANCE_MODE', isMaintenanceModeOn => isMaintenanceModeOn);
/* It's only for firefox, because there is disabled getting text from clipboard */
const COPY_TO_CLIPBOARD = createAction('COPY_TO_CLIPBOARD', copyData => copyData);

const switchUserContractorMode = createAsyncAction('SWITCH_USER_MODE', function() {
  return (dispatch, getState) => {
    const { user, general } = getState();
    const last_managed_business_handle = user.getIn(['userMetadata', 'last_managed_business_handle']);
    const isBusinessMode = general.get('isBusinessMode');
    let route = '/i';
    if (!isBusinessMode) {
      route = loadHistory({ last_managed_business_handle });
      route = route.includes('page') ? route : '/page/create';
    }
    dispatch(push(route));
    dispatch(this.success(route));
  };
});

export default {
  OPEN_LOGOUT_DIALOGUE,
  CLOSE_LOGOUT_DIALOGUE,
  resize,
  TOGGLE_MENU,
  TOGGLE_MENU_MOBILE,
  GET_USER_WALLET_ADDRESS,
  SET_BUSINESS_MODE,
  SET_BACKEND_MODE,
  SHOW_WELCOME_MODAL,
  SET_MAINTENANCE_MODE,
  SET_BUSINESS_MODE_PATH,
  COPY_TO_CLIPBOARD,
  ...switchUserContractorMode,
};
